import axios from '../config/axios.js';

const API_BASE = '/mobile/app-config';

const appConfigService = {
  getMobileAppConfig: async () => {
    const response = await axios.get(API_BASE);
    return response.data?.data ?? response.data;
  },
};

export default appConfigService;
